import React from "react";
import { Factory, Zap, Wrench, DraftingCompass } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UnsereKompetenzfelder() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const solutions = [{
    title: "Tiefbau & Kanalisation",
    items: ["Kanalbau & Entwässerung", "Hausanschlüsse", "Zisternen & Rigolen", "Schachtbauwerke"],
    icon: Factory,
    titleClassName: "bg-card text-card-foreground flex flex-col gap-6 py-6 group group group group relative overflow-hidden border border-border rounded-sm transition-all duration-300 !bg-[hsl(46,97%,65%)] hover:bg-muted/30 hover:shadow-xl hover:border-primary/30 !bg-[url(https://joint-slug.10web.cloud/wp-content/uploads/2026/03/Erstellen-wir-Bilder-von-Kanalarbeiten-wo-Erde-viel-ausgehoben-wird.-Wo-es-mehr-um-die-Bau-und-Erdarbeiten-geht.jpg)]"
  }, {
    title: "Erdbau & Aushub",
    items: ["Baugrubenaushub", "Bodenmanagement", "Geländemodellierung", "Bodenverdichtung"],
    icon: Zap,
    titleClassName: "group group group bg-card !bg-[url(https://joint-slug.10web.cloud/wp-content/uploads/2026/03/erdarbeiten.webp)] text-card-foreground flex flex-col gap-6 py-6 group group group group relative overflow-hidden border border-border rounded-sm transition-all duration-300 !bg-[hsl(46,97%,65%)] hover:bg-muted/30 hover:shadow-xl hover:border-primary/30 !bg-[url(https://joint-slug.10web.cloud/wp-content/uploads/2026/03/industry_logistics.webp)]"
  }, {
    title: "Außenanlagen",
    items: ["Hangbefestigung", "Gartenneuanlage", "Zaun- & Mauerbau", "Treppenanlagen"],
    icon: Wrench,
    titleClassName: "group group group group bg-card !bg-[url(https://joint-slug.10web.cloud/wp-content/uploads/2026/03/industry_retail.webp)] text-card-foreground flex flex-col gap-6 py-6 group group group group relative overflow-hidden border border-border rounded-sm transition-all duration-300 !bg-[hsl(46,97%,65%)] hover:bg-muted/30 hover:shadow-xl hover:border-primary/30 !bg-[url(https://joint-slug.10web.cloud/wp-content/uploads/2026/03/garten.png)]"
  }, {
    title: "Pflasterbau & Wege",
    items: ["Einfahrten & Hoflächen", "Großflächenpflaster", "Natursteinverlegung", "Parkplatzbau"],
    icon: DraftingCompass,
    titleClassName: "group group group group group bg-card !bg-[url(https://joint-slug.10web.cloud/wp-content/uploads/2026/03/aussenanlagen.webp)] text-card-foreground flex flex-col gap-6 py-6 group group group group relative overflow-hidden border border-border rounded-sm transition-all duration-300 !bg-[hsl(46,97%,65%)] hover:bg-muted/30 hover:shadow-xl hover:border-primary/30 !bg-[url(https://joint-slug.10web.cloud/wp-content/uploads/2026/03/pflasterbau.webp)]"
  }, {
    title: "Außenanlagen",
    items: ["Gartengestaltung", "Zaunbau", "Grünanlagen"],
    icon: Factory
  }];
  return <section data-section-id="61801" id="unser-leistungsportfolio" className="py-16 relative overflow-hidden !bg-[hsl(48,96%,53%)] md:py-24 !bg-[url(https://tm-bauservices.de/wp-content/uploads/2026/03/pflasterbau.webp)]">
      <div className="container mx-auto px-4">
        <div className="mb-12 md:mb-16 text-center max-w-3xl mx-auto">
          
          <p className="font-sans !font-extrabold !text-3xl !text-[hsl(0,0%,100%)] !bg-[hsl(0,0%,0%)]">Präzise Ausführung für anspruchsvolle Bauprojekte. Wir schaffen das stabile Fundament für Ihre Visionen – schnell, zuverlässig und regional.</p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {solutions.map((solution, i) => {
          const Icon = solution.icon;
          return <Card key={i} data-index={i} className="group group group group text-card-foreground flex flex-col gap-6 py-6 group group group group relative overflow-hidden border border-border rounded-sm transition-all duration-300 !bg-[hsl(45,93%,47%)] hover:bg-muted/30 hover:shadow-xl hover:border-primary/30">
                <CardHeader className="pb-2">
                  <div className="flex items-start justify-between !text-[hsl(0,0%,100%)]">
                    <CardTitle className="text-2xl font-bold font-sans tracking-tight !text-[hsl(0,0%,100%)] md:text-3xl">
                      {solution.title}
                    </CardTitle>
                    <div className="p-3 rounded-sm bg-muted text-primary transition-transform duration-500 group-hover:rotate-3 group-hover:scale-105 group-hover:bg-primary group-hover:text-primary-foreground">
                      <Icon className="w-8 h-8 md:w-10 md:h-10 stroke-[2]" />
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3 mt-4 font-mono !opacity-[1] !bg-transparent !text-[hsl(210,17%,98%)]">
                    {solution.items.map((item, idx) => <li key={idx} data-index={idx} className="flex items-center !text-[hsl(0,0%,100%)]">
                        <span className="w-2 h-2 rounded-sm bg-primary mr-4 shrink-0" />
                        <span className="text-sm md:text-base font-medium uppercase tracking-wide">{item}</span>
                      </li>)}
                  </ul>
                </CardContent>
                {}
                <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
              </Card>;
        })}
        </div>
      </div>
    </section>;
}